export default __webpack_public_path__ + "static/awaiting-27d6c90a9a91b89cfee603ab38d7538d.png";